<template>
	<div class="footer_top_box">
		<div class="container">
			<!-- 上半部分 -->
			<ul class="footer_top_assurance clearfix">
				<li v-for="(item, index) in assurance"
					:key="index">
					<img :src="require('@/assets/'+item.src)" alt="">
					<span>{{item.title}}</span>
				</li>
			</ul>
			<!-- 下半部分 -->
			<div class="footer_top_column">
				<el-row>
				  <!-- 左侧 -->
				  <el-col :span="17">
					<el-row>
						<!-- 帮助中心列 -->
						<el-col :span="6">
							<ul class="footer_top_column_service">
								<!-- 标题 -->
								<li class="footer_top_column_service_title">{{$t("message.footer.help")}}</li>
								<li v-for="item in column1"
									:key="item.id">
									<router-link :to="{name: 'help',query: {id:item.column_id}}">{{item.name}}</router-link>
								</li>
							</ul>
						</el-col>
						<!-- 服务支持列 -->
						<el-col :span="6">
							<ul class="footer_top_column_service">
								<!-- 标题 -->
								<li class="footer_top_column_service_title">{{$t("message.footer.serve")}}</li>
								<li v-for="item in column2"
									:key="item.id">
									<router-link :to="{name: 'serve',query: {id:item.column_id}}">{{item.name}}</router-link>
								</li>
							</ul>
						</el-col>
						<!-- 线下门店列 -->
						<el-col :span="6">
							<ul class="footer_top_column_service">
								<!-- 标题 -->
								<li class="footer_top_column_service_title">{{$t("message.footer.store")}}</li>
								<li v-for="item in column3"
									:key="item.id">
									<router-link :to="{name: 'store',query: {id:item.column_id}}">{{item.name}}</router-link>
								</li>
							</ul>
						</el-col>
						<!-- 店铺加盟列 -->
						<el-col :span="6">
							<ul class="footer_top_column_service">
								<!-- 标题 -->
								<li class="footer_top_column_service_title">{{$t("message.footer.join")}}</li>
								<li v-for="item in column4"
									:key="item.id">
									<router-link :to="{name: 'join',query: {id:item.column_id}}">{{item.name}}</router-link>
								</li>
							</ul>
						</el-col>
					</el-row>
				  </el-col>
				  <!-- 右侧 -->
				  <el-col :span="7">
					<div class="footer_top_column_online">
						<p class="footer_top_column_online_phone">28362020/28362022</p>
						<p class="footer_top_column_online_time">{{$t("message.footer.time")}}</p>
						<p class="footer_top_column_online_time">{{$t("message.footer.only")}}</p>
						<div class="footer_top_column_online_service">{{$t("message.footer.online")}}</div>
					</div>
				  </el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data() {
		return {
			// 承诺参数
			assurance: [
				{
					src: "img/footer/footer_icon01.png",
					title: this.$t("message.footer.assurance1")
				},
				{
					src: "img/footer/footer_icon02.png",
					title: this.$t("message.footer.assurance2")
				},
				{
					src: "img/footer/footer_icon03.png",
					title: this.$t("message.footer.assurance3")
				},
				{
					src: "img/footer/footer_icon04.png",
					title: this.$t("message.footer.assurance4")
				},
				{
					src: "img/footer/footer_icon05.png",
					title: this.$t("message.footer.assurance5")
				},
			],
		}
	},
	computed: mapState({
		column1: state => state.other.column1,
		column2: state => state.other.column2,
		column3: state => state.other.column3,
		column4: state => state.other.column4,
	}),
}
</script>

<style scoped>
/* 组件盒子 */
.footer_top_box{
	background-color: #fff;
}
/* 承诺 */
.footer_top_assurance {
	margin-top: 27px;
	margin-bottom: 40px;
	padding-bottom: 27px;
	border-bottom: 1px solid #e0e0e0;
}
.footer_top_assurance>li {
	float: left;
	width: 228px;
	border-right: 1px solid #e0e0e0;
	text-align: center;
}
.footer_top_assurance>li:last-child {
  	border-right: 0;
}
.footer_top_assurance>li>img {
	display: inline-block;
	vertical-align: middle;
	width: 20px;
	margin-right: 10px;
}
.footer_top_assurance>li>span{
	display: inline-block;
	vertical-align: middle;
}

/*页脚下半部分*/
.footer_top_column{
  	padding-bottom: 40px;
}
/*左侧*/
.footer_top_column_service > li{
  	margin-bottom: 15px;
}
/* 字体 */
.footer_top_column_service > li > a{
	color: #757575;
	font-family: "\5B8B\4F53";
	font-size: 12px;
}
.footer_top_column_service > li > a:hover{
  	color: #ff6700;
}
/* 标题 */
.footer_top_column_service > li.footer_top_column_service_title{
	color: #424242;
	font-family: "\5FAE\8F6F\96C5\9ED1";
	margin-bottom: 28px;
}

/*右侧*/
.footer_top_column_online {
	text-align: center;
	border-left: 1px solid #e0e0e0;
}
.footer_top_column_online_phone{
	font-size:20px; 
	color:#ff6700; 
	margin-bottom:10px;
}
.footer_top_column_online_time{
	font-size:12px; 
	font-family:Arial,'宋体'; 
	color:#616161; 
	margin-bottom:7px;
}
.footer_top_column_online_service {
	margin: 0 auto;
	width: 120px;
	height: 30px;
	line-height: 30px;
	margin-top: 18px;
	text-align: center;
	color: #ff6700;
	font-size: 12px;
	border: 1px solid #ff6700;
}
</style>
